export default "__VITE_ASSET__DQNAxwfR__"